document.addEventListener('DOMContentLoaded',function(){
  var lang=(document.documentElement.lang||'en').toLowerCase();
  var isEn=lang.indexOf('en')===0;
  var nav=document.querySelector('.aa-global-nav');
  if(nav){
    var home=nav.querySelector('.aa-global-nav__links > a[href="/"]');
    var academy=nav.querySelector('.aa-global-nav__links > a[href="/#academy"]');
    var trigger=nav.querySelector('.aa-global-products__trigger');
    var story=nav.querySelector('.aa-global-nav__links > a[href="/#about"]');
    var all=nav.querySelector('.aa-global-products__all');
    var cart=nav.querySelector('.aa-global-cart');
    if(home)home.textContent=isEn?'Home':'Inicio';
    if(academy)academy.textContent=isEn?'Maker Course':'Curso Maker';
    if(trigger)trigger.textContent=isEn?'Products':'Productos';
    if(story)story.textContent=isEn?'Our Story':'Nuestra historia';
    if(all)all.textContent=isEn?'View all':'Ver todos';
    if(cart)cart.setAttribute('aria-label',isEn?'Cart':'Carrito');
  }
  var root=document.querySelector('.aa-cart');
  if(!root)return;
  var set=function(sel,en,es){var el=root.querySelector(sel);if(el)el.textContent=isEn?en:es;};
  var setAll=function(sel,en,es){root.querySelectorAll(sel).forEach(function(el){el.textContent=isEn?en:es;});};
  if(root.querySelector('.aa-empty')){
    set('.aa-empty h1','Your cart is empty','Tu carrito está vacío');
    set('.aa-empty p','Your next personalized creation is waiting for you.','Tu próxima creación personalizada te está esperando.');
    set('.aa-empty-button','VIEW PRODUCTS','VER PRODUCTOS');
    return;
  }
  set('.aa-title-wrap h1','Your cart','Tu carrito');
  set('.aa-continue','←  Continue shopping','←  Seguir comprando');
  var heads=root.querySelectorAll('.aa-grid-head span');
  var labels=isEn?['Product','Price','Quantity','Total']:['Producto','Precio','Cantidad','Total'];
  heads.forEach(function(el,i){if(labels[i])el.textContent=labels[i];});
  setAll('.aa-remove',isEn?'Remove':'Eliminar',isEn?'Remove':'Eliminar');
  root.querySelectorAll('.aa-qty').forEach(function(qty){
    qty.setAttribute('aria-label',isEn?'Quantity':'Cantidad');
    var minus=qty.querySelector('[data-aa-minus]'),plus=qty.querySelector('[data-aa-plus]'),input=qty.querySelector('input');
    if(minus)minus.setAttribute('aria-label',isEn?'Decrease quantity':'Disminuir cantidad');
    if(plus)plus.setAttribute('aria-label',isEn?'Increase quantity':'Aumentar cantidad');
    if(input)input.setAttribute('aria-label',isEn?'Product quantity':'Cantidad del producto');
  });
  var benefits=root.querySelectorAll('.aa-benefit');
  var benefitText=isEn?[
    ['Made with love','Every piece is unique and personalized'],
    ['Secure payment','Your information is protected'],
    ['Reliable shipping','Receive your order right at your door']
  ]:[
    ['Hecho con amor','Cada pieza es única y personalizada'],
    ['Pago seguro','Tus datos están protegidos'],
    ['Envío confiable','Recibe tu pedido directo a tu puerta']
  ];
  benefits.forEach(function(box,i){var strong=box.querySelector('strong'),p=box.querySelector('p');if(strong&&benefitText[i])strong.textContent=benefitText[i][0];if(p&&benefitText[i])p.textContent=benefitText[i][1];});
  set('.aa-notes h3',isEn?'✣  Important notes':'✣  Notas importantes',isEn?'✣  Important notes':'✣  Notas importantes');
  var notes=root.querySelectorAll('.aa-notes li');
  var noteText=isEn?[
    'Estimated production time: 3–7 business days.',
    'Carefully review your design before confirming your order.',
    'No changes or returns once the product has entered production.',
    'Design colors may vary slightly in the final product.'
  ]:[
    'Producción estimada en 3–7 días hábiles.',
    'Revisa cuidadosamente tu diseño antes de confirmar tu pedido.',
    'No realizamos cambios ni devoluciones una vez que el producto está en producción.',
    'Colores del diseño pueden variar ligeramente en el resultado final.'
  ];
  notes.forEach(function(el,i){if(noteText[i])el.textContent=noteText[i];});
  set('.aa-summary h2','Order summary','Resumen del pedido');
  var rows=root.querySelectorAll('.aa-summary-row');
  rows.forEach(function(row){
    var first=row.querySelector('span:first-child, strong:first-child');
    if(!first)return;
    var t=first.textContent.trim();
    if(t==='Descuento'||t==='Discount')first.textContent=isEn?'Discount':'Descuento';
    if(t==='Subtotal')first.textContent='Subtotal';
    if(t==='Envío'||t==='Shipping')first.textContent=isEn?'Shipping':'Envío';
    if(t==='Total estimado'||t==='Estimated total')first.textContent=isEn?'Estimated total':'Total estimado';
  });
  var muted=root.querySelector('.aa-summary-muted');if(muted)muted.textContent=isEn?'Calculated at checkout':'Calculado en el checkout';
  set('.aa-tax-note','Taxes and shipping calculated at checkout.','Impuestos y envíos calculados en el checkout.');
  var checkout=root.querySelector('.aa-checkout');if(checkout)checkout.innerHTML='<span>🔒</span> '+(isEn?'PROCEED TO CHECKOUT':'PROCEDER AL CHECKOUT');
});